//引入刚才的http.js文件
import qs from 'qs'
import https from './index'
//设置个对象，就不用一个个暴露了，直接暴露对象
let apiFun = {}

/* 获取列表 */
//查询列表，详情就是get
/* /api/getlist是请求接口地址，有http.js里面的Ip加上，如：http:192.168.0.1:9090//api/getlist  */
//保存都是post
// 仓库构建接口
//仓库列表
apiFun.getWarehouseList = function (data) {
  return https.get('/bpi/warehouse/getWarehouseList', data)
}

//初始化
apiFun.initWarehouse = function (data) {
  return https.post('/bpi/warehouse/initWarehouse', data)
}

apiFun.getDicts = function (dictType) {
  return https.get('/bpi/system/dict/data/type/' + dictType)
}

apiFun.upload = function (data) {
  return https.post('/bpi/' + '/common/upload', data)
}

// ---------------------------仓库---------------------------------
// 获取仓库信息货架
apiFun.getWarehouseInfo = function (params) {
  return https.get('/bpi/warehouse/getWarehouseInfo/' + params)
}
// 获取路径
apiFun.getSolution = function (params) {
  return https.get('/bpi/orderpicking/getSolution/' + params)
}
//----------------------------获取仓库货架里面的货位-----------------

// 获取货架列表
apiFun.getShelfList = function () {
  return https.get('/bpi/warehouse/shelf/getShelfList')
}
// 初始化货架
apiFun.initShelf = function (params) {
  return https.post('//bpi/warehouse/shelf/initShelf', params)
}
// 获取货位列表
apiFun.getLocationList = function (params) {
  return https.get('/bpi/warehouse/shelf/getLocationList', params)
}
//首页初始化，获取每个库位目前存储的货物统计（统计体积）信息
apiFun.getLocationUsedVolume = function (params) {
  return https.post('/bpi/warehouse/stock/getLocationUsedVolume', params)
}
// 获取单个货位详细信息
apiFun.getLocationInfo = function (warehouseId, locationCode) {
  return https.get('/bpi/warehouse/shelf/getLocationInfo/' + warehouseId + '/' + locationCode)
}

// --------------------------看板主题-------------------------------
// 获取看板主题列表
apiFun.getPanelThemeList = function () {
  return https.get('/bpi/infinite/paneltheme/getPanelThemeList')
}
// 获取看板主题专项列表
apiFun.getPanelThemeItemList = function (data) {
  return https.get('/bpi/infinite/paneltheme/getPanelThemeItemList', data)
}
// 获取看板项关键字查询列表
apiFun.getPanelThemeFieldList = function (data) {
  return https.get('/bpi/infinite/paneltheme/getPanelThemeFieldList?themeId=' + data)
}
// 获取看板视图列表
apiFun.getPanelView = function (data, panelId) {
  return https.get('/bpi/infinite/panel/getPanelView/' + data + '/' + panelId)
}
// 获取看板视图项列表（左边点击拿到货位要变颜色的列表）
apiFun.getPanelItemView = function (data) {
  return https.post('/bpi/infinite/panel/getPanelItemView', data)
}

//---------------------------看板-------------------------------
// 获取看板列表
apiFun.getPanelList = function (data) {
  return https.get('/bpi/infinite/panel/getPanelList', data)
}
// 获取看板专项列表
apiFun.getPanelItemList = function (data) {
  return https.get('/bpi/infinite/panel/getPanelItemList', data)
}
// 获取看板专项明细列表
apiFun.getPanelItemDetailList = function (data) {
  return https.get('/bpi/infinite/panel/getPanelItemDetailList', data)
}
// 保存看板
apiFun.savePanel = function (data) {
  return https.post('/bpi/infinite/panel/savePanel', data)
}
// 保存看板项
apiFun.savePanelItem = function (data) {
  return https.post('/bpi/infinite/panel/savePanelItem', data)
}
// 批量保存看板项
apiFun.batchSavePanelItem = function (data) {
  return https.post('/bpi/infinite/panel/batchSavePanelItem', data)
}
// 删除看板项
apiFun.deletePanelItem = function (data) {
  return https.post('/bpi/infinite/panel/deletePanelItem', data)
}
// ----------------------------字典------------------------------
// 字典列表拿到运算符,单位
apiFun.dictType = function (data) {
  return https.get('/bpi/system/dict/data/type/' + data)
}
// 字典列表
apiFun.dictList = function () {
  return https.get('/bpi/system/dict/data/list')
}

// -------------------拣货------------------------------------------
// 创建拣货
apiFun.buildPickingTask = function (data) {
  return https.post('/bpi/orderpicking/buildPickingTask', data)
}
// 创建拣货任务(先创建，然後WebSocket返回数据)
apiFun.buildSimulatorPickingTask = function (data) {
  return https.post('/bpi/orderpicking/buildSimulatorPickingTask', data)
}
// 创建工作任务(先创建，然後WebSocket返回数据)
apiFun.buildWorkTask = function (data) {
  return https.post('/bpi/orderpicking/buildWorkTask', data)
}
// 执行任务
apiFun.executeTask = function (data) {
  return https.post('/bpi/orderpicking/executeTask', data)
}
// 停止拣货任务(中止后台推送)
apiFun.simulatorStop = function (data) {
  return https.post('/bpi/orderpicking/simulator/stop', data)
}
// 获取拣货信息
apiFun.getPickingInfo = function (data) {
  return https.get('/bpi/orderpicking/getPickingTaskInfo/' + data)
}
// 拣货资源方案求解路径
apiFun.sourseSolve = function (data) {
  return https.post('/bpi/orderpicking/source/solve', data)
}
// 拣货时间方案求解路径
apiFun.solve = function (data) {
  return https.post('/bpi/orderpicking/solve', data)
}
// 获取路径
apiFun.getSolution = function (warehouseId) {
  return https.get('/bpi/orderpicking/getSolution/' + warehouseId)
}
// 拣货资源方案停止任务
apiFun.sourceStop = function (data) {
  return https.post('/bpi/orderpicking/source/stop', data)
}
// 拣货时间方案停止任务
apiFun.stop = function (data) {
  return https.post('/bpi/orderpicking/stop', data)
}
// 小推车列表
apiFun.getTrolleyList = function (data) {
  return https.get('/bpi/warehouse/trolley/getTrolleyList', data)
}
// 小推车表格下载
// apiFun.orderpickingExport = function (data) {
//   // return https.post("/bpi/express/download", data);
//   return _axios({
//     url: '/bpi/orderpicking/export',
//     method: 'post',
//     data,
//     responseType: 'blob',
//   })
// }
// 保存任务结果
apiFun.store = function (data) {
  return https.post('/bpi/orderpicking/store', data)
}
// 计算任务结果列表
apiFun.getHisTaskList = function (data) {
  return https.get('/bpi/orderpicking/getHisTaskList', data)
}
// 更新批次状态
apiFun.updateResultState = function (data) {
  return https.post('/bpi/pickingreport/updateResultState', data)
}
// ----------------个人信息------------------------------

// 得到自定义看板、库位优化、拣货沙盘等路由
apiFun.getRouters = function () {
  return https.get('/bpi/getRouters')
}

//-----------------------快递配送-------------------------------------
// 创建快递任务
apiFun.buildExpressTask = function (data) {
  return https.post('/bpi/express/buildExpressTask', data)
}
// 获取任务信息
apiFun.getTaskInfo = function (data) {
  return https.get('/bpi/express/getTaskInfo/' + data)
}
// 计算快递任务
apiFun.expressSolve = function (data) {
  return https.post('/bpi/express/solve', data)
}
// 终止快递任务
apiFun.expressStop = function (data) {
  return https.post('/bpi/express/stop', data)
}
// 保存快递任务
apiFun.expressStore = function (data) {
  return https.post('/bpi/express/store', data)
}
// 获取历史快递任务
apiFun.expressGetTaskList = function (data) {
  return https.get('/bpi/express/getTaskList', data)
}
// 快递明细表格下载
// apiFun.download = function (data) {
//   // return https.post("/bpi/express/download", data);
//   return _axios({
//     url: '/bpi/express/download',
//     method: 'post',
//     data,
//     responseType: 'blob',
//   })
// }

//获取RFID标签的基础数据
apiFun.getSignsList = function () {
  return https.get('/bpi//inventory/listEpcBase')
}

//获取盘点任务列表
apiFun.getInventoryTaskList = function (data) {
  return https.get('/bpi/inventory/listTask', data)
}

apiFun.getInventoryResultList = function (data) {
  return https.get('/bpi/inventory/listEpc/' + data.taskId)
}

// 汇总明细
apiFun.getSummaryDetail = function (data) {
  return https.post('/bpi/express/getSummaryDetail', qs.stringify(data))
}

// 获取kiva小车停靠站点列表
apiFun.getVehicleStationList = function (data) {
  return https.get('/bpi/warehouse/vstation/getVehicleStationList', data)
}

//获取kiva小车/叉车设备列表
apiFun.getEquipmentList = function (data) {
  return https.get('/bpi/warehouse/equipment/getEquipmentList', data)
}

//获取员工列表
apiFun.getStaffList = function (data) {
  return https.get('/bpi/warehouse/staff/getStaffList', data)
}

//获取库区列表
apiFun.getAreaList = function (data) {
  return https.get('/bpi/warehouse/area/getAreaList', data)
}

//构建上架任务
apiFun.buildStackingTask = function (data) {
  return https.post('/bpi/orderstacking/buildStackingTask', data)
}

//获取模拟演示的执行结果统计数据
apiFun.getSimulatorTotalInfo = function (data) {
  return https.get('/bpi/orderpicking/getExecutorResult', data)
}

//下载模板
apiFun.downTemplate = function (data) {
  return https.post('/bpi/system/template/downTemplate', data)
}

//创建工作任务(Excel数据)---拣货
// apiFun.buildWorkTaskFromExcel = function (data) {
//   // return https.post("/bpi/orderpicking/buildWorkTaskFromExcel", data);
//   return _axios({
//     url: '/bpi/orderpicking/buildWorkTaskFromExcel',
//     method: 'post',
//     data,
//     responseType: 'blob',
//   })
// }

// 导入出库订单
// apiFun.importOutOrder = function (data) {
//   // return https.post("/bpi/orderpicking/buildWorkTaskFromExcel", data);
//   return _axios({
//     url: '/bpi/orderpicking/importOutOrder',
//     method: 'post',
//     data,
//     responseType: 'blob',
//   })
// }

// 创建上架任务（Excel数据）--上架
// apiFun.buildStackingTaskFromExcel = function (data) {
//   // return https.post("/bpi/orderpicking/buildWorkTaskFromExcel", data);
//   return _axios({
//     url: '/bpi/orderstacking/buildStackingTaskFromExcel',
//     method: 'post',
//     data,
//     responseType: 'blob',
//   })
// }

//导出拣货模拟明细
// apiFun.exportTaskDetail = function (data) {
//   // return https.post("/bpi/orderpicking/exportTaskDetail", data);
//   return _axios({
//     url: '/bpi/orderpicking/exportTaskDetail',
//     method: 'post',
//     data,
//     responseType: 'blob',
//   })
// }

//导出上架模拟明细
// apiFun.exportStackingDetail = function (data) {
//   // return https.post("/bpi/orderpicking/exportTaskDetail", data);
//   return _axios({
//     url: '/bpi/orderstacking/exportStackingDetail',
//     method: 'post',
//     data,
//     responseType: 'blob',
//   })
// }

// 执行拣货任务
// apiFun.executeTask = function (data) {
//   return https.post('/bpi/orderpicking/executeTask', data)
//   // return _axios({
//   //   url: "/bpi/orderpicking/executeTask",
//   //   method: "post",
//   //   data,
//   //   // timeout:1000*60*30
//   // })
// }

// 执行上架任务
// apiFun.stackingExecute = function (data) {
//   return https.post('/bpi/orderstacking/stackingExecute', data)
//   // return _axios({
//   //   url: "/bpi/orderpicking/executeTask",
//   //   method: "post",
//   //   data,
//   //   // timeout:1000*60*30
//   // })
// }

//重置密码
apiFun.resetPwd = function (data) {
  return https.post('/bpi/system/user/resetPwd', data)
}

// 仓库类型
apiFun.warehouseType = function () {
  return https.get('/bpi/system/dict/data/type/warehouse_type')
}

// 根据参数键名查询参数值
apiFun.getConfigKey = function (configKey) {
  return https.get('/bpi/system/config/configKey/' + configKey)
}

// 获取地址列表
apiFun.getAreaList = function (data) {
  return https.get('/bpi/common/getAreaList', data)
}

// 仓库监控大屏
apiFun.screenSummary = function (data) {
  return https.get('/screen/summary/' + data)
}

// 产品列表
apiFun.getProductList = function (data) {
  return https.get('/bpi/product/getProductList', data)
}

// 导入产品
// apiFun.importProduct = function (data) {
//   return _axios({
//     url: '/bpi/product/importProduct',
//     method: 'post',
//     data,
//     responseType: 'blob',
//   })
// }

// 产品库存
apiFun.getStockList = function (data) {
  return https.get('/bpi/product/stock/getStockList', data)
}

// 导入产品库存
// apiFun.importStock = function (data) {
//   return _axios({
//     url: '/bpi/product/stock/importStock',
//     method: 'post',
//     data,
//     responseType: 'blob',
//   })
// }

// 获取仓库JSON文件前缀参数地址
apiFun.configKey = function (data) {
  return https.get('/bpi/system/config/configKey', data)
}
// -----------------------------------------------仓库成本核算-----------------------------------------------
// 成本沙盘推演
apiFun.costSand = function (data) {
  return https.post('/bpi/sand/costSand', data)
}

// 沙盘推演结果
apiFun.getDeduceResult = function (taskId) {
  return https.get('/bpi/sand/getDeduceResult/' + taskId)
}

// 沙盘推演配置
apiFun.configSave = function (data) {
  return https.post('/bpi/sand/config/save', data)
}

// 拉取成本少盘配置信息
apiFun.configGetInfo = function (data) {
  return https.get('/bpi/sand/config/getInfo/' + data)
}

// 仓库设备规格
apiFun.getSpecList = function (data) {
  return https.get('/bpi/warehouse/espec/getSpecList', data)
}

// 产品列表
apiFun.getProductList = function (data) {
  return https.get('/bpi/product/getProductList', data)
}

//暴露出这个对象
export default apiFun
